import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck, UserPlus, Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

/** Admin → Utilisateurs : liste des administrateurs + formulaire « Ajouter un administrateur ». */
export default function AdminAccountsCard() {
  const [admins, setAdmins] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", password: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/admins").then(({ data }) => setAdmins(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || form.password.length < 8) return toast.error("E-mail requis et mot de passe de 8 caractères minimum");
    setBusy(true);
    try {
      const { data } = await api.post("/admin/admins", form);
      toast.success(data.created ? `Administrateur ${data.email} créé` : `${data.email} promu administrateur (mot de passe mis à jour)`);
      setForm({ email: "", name: "", password: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || err.userMessage || "Création impossible"); } finally { setBusy(false); }
  };

  return (
    <div className="bg-white rounded-3xl border border-[#EADDC9] p-6 mb-8" data-testid="admin-accounts-card">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="min-w-[240px]">
          <p className="caption-label text-[#A26F3E] inline-flex items-center gap-2"><ShieldCheck className="w-3.5 h-3.5" /> Administrateurs</p>
          <ul className="mt-3 space-y-1.5" data-testid="admin-accounts-list">
            {admins.map((a) => (
              <li key={a.user_id} className="text-sm text-[#1A1A1A]"><span className="font-medium">{a.name || "—"}</span> <span className="text-[#8B8680]">· {a.email}</span></li>
            ))}
          </ul>
        </div>
        <form onSubmit={submit} className="flex-1 min-w-[280px] grid sm:grid-cols-[1fr_1fr_1fr_auto] gap-2 items-end" data-testid="admin-create-form">
          <label className="text-xs text-[#6E4B2A]">Nom<Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Prénom Nom" className="mt-1 rounded-xl" data-testid="admin-create-name" /></label>
          <label className="text-xs text-[#6E4B2A]">E-mail<Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="admin@helencia.fr" className="mt-1 rounded-xl" data-testid="admin-create-email" /></label>
          <label className="text-xs text-[#6E4B2A] relative">Mot de passe
            <Input type={show ? "text" : "password"} required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="8 caractères min." className="mt-1 rounded-xl pr-9" data-testid="admin-create-password" />
            <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2 bottom-2 text-[#8B8680]" aria-label="Afficher">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
          </label>
          <Button type="submit" disabled={busy} className="rounded-xl bg-[#1A1A1A] hover:bg-[#C68E59] text-white h-10" data-testid="admin-create-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><UserPlus className="w-4 h-4 mr-1.5" /> Ajouter</>}
          </Button>
        </form>
      </div>
      <p className="text-[11px] text-[#8B8680] mt-4">Un compte existant avec cet e-mail sera promu administrateur et son mot de passe remplacé. Le compte est actif immédiatement, sans e-mail de confirmation.</p>
    </div>
  );
}
